"use strict";
exports.__esModule = true;
exports.parseToBoolean = exports.isBoolean = void 0;
var isBoolean = function (value) {
    if (typeof value === 'boolean') {
        return true;
    }
    else if (typeof value === 'string') {
        var lowercaseValue = value.toLowerCase();
        return lowercaseValue === 'true' || lowercaseValue === 'false';
    }
    else {
        return false;
    }
};
exports.isBoolean = isBoolean;
var parseToBoolean = function (value) {
    if (typeof value === 'boolean') {
        return value;
    }
    else if (typeof value === 'string') {
        var lowercaseValue = value.toLowerCase();
        if (lowercaseValue === 'true') {
            return true;
        }
        else if (lowercaseValue === 'false') {
            return false;
        }
    }
    return null;
};
exports.parseToBoolean = parseToBoolean;
